<template>
  <div :class="['group', condensed ? 'group--condensed' : '', borderless ? 'group--borderless' : '']">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    condensed: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.group {
  display: flex;
  margin: 0px 8px;
  border-left: 1px solid $black;
  border-right: 1px solid rgba($white, 0.1);

  &--condensed {
    margin: 0px;
  }

  &--borderless {
    border-left: none;
    border-right: none;
  }
}

</style>
